"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getComponent = getComponent;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _constants = require("../definitions/constants");

var _react = _interopRequireDefault(require("react"));

var _QdLearningQuestionContainer = _interopRequireDefault(require("../containers/QdLearningQuestionContainer"));

var _QdLearningSeriesContainer = _interopRequireDefault(require("../containers/QdLearningSeriesContainer"));

var _SeriesContextProvider = _interopRequireDefault(require("../context/SeriesContextProvider"));

var _QdLearningPromptContainer = _interopRequireDefault(require("../containers/QdLearningPromptContainer"));

var _QdLearningAnswerContainer = _interopRequireDefault(require("../containers/QdLearningAnswerContainer"));

function getComponent(props) {
  var specificProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (props.type) {
    case _constants.DIALOG_TYPES.QUESTION:
      return /*#__PURE__*/_react["default"].createElement(_QdLearningQuestionContainer["default"], (0, _extends2["default"])({}, props, {
        goToNextDialog: specificProps.goToNextDialog
      }));

    case _constants.DIALOG_TYPES.PROMPT:
      return /*#__PURE__*/_react["default"].createElement(_QdLearningPromptContainer["default"], props);

    case _constants.DIALOG_TYPES.ANSWER:
      return /*#__PURE__*/_react["default"].createElement(_QdLearningAnswerContainer["default"], (0, _extends2["default"])({}, props, {
        onAnswer: specificProps.onAnswer
      }));

    case _constants.DIALOG_TYPES.SERIES:
      return /*#__PURE__*/_react["default"].createElement(_SeriesContextProvider["default"], null, /*#__PURE__*/_react["default"].createElement(_QdLearningSeriesContainer["default"], props));

    default:
      return null;
  }
}